import React, { useEffect, useState } from "react";
import UpgradeYourPlan from "./child/UpgradeYourPlan";
import RevenueStatisticOne from "./child/RevenueStatisticOne";
import SupportTracker from "./child/SupportTracker";
import AverageDailySales from "./child/AverageDailySales";
import TransactionsTwo from "./child/TransactionsTwo";
import SalesByCountries from "./child/SalesByCountries";
import SourceVisitors from "./child/SourceVisitors";
import MonthlyCampaignState from "./child/MonthlyCampaignState";
import RecentActivityOne from "./child/RecentActivityOne";
import PortalLogo from "./utils/PortalLogo";

const DashBoardLayerNine = () => {

  const [strRoles, setStrRoles] = useState('');


  useEffect(() => {

    setStrRoles(localStorage.getItem('roles'))

  }, []);

  function hasRole(roleToFind) {
    return strRoles.includes(roleToFind);
  }

  return (

    <div className='row gy-4'>
      {/* Mostrar bienvenida SOLO si es Trabajador o Consulta y NO es Administrador */}
      {((hasRole('TRABAJADOR') || hasRole('CONSULTA')) && !hasRole('ADMINISTRADOR')) && (
        <>
          {/* Encabezado */}
          <div className='text-center mb-1'>
            <div className='row'>
              <div className='col-md-4'></div>
              <div className='col-md-4 mb-3'>
                <PortalLogo className='light-logo' style={{ width: 150 }} />
              </div>
              <div className='col-md-4'></div>
            </div>
            <h4 className='mb-5 text-primary-600'>
              H. XVIII AYUNTAMIENTO DE COMONDÚ
            </h4>
          </div>

          {/* Mensaje de bienvenida */}
          <p className='mb-10 text-secondary-light text-lg'>
            <strong>¡Bienvenido(a) a la Plataforma del Trabajador de Comondú!</strong>
            Este portal ha sido diseñado especialmente para ti, con el objetivo de facilitar
            el acceso a tu información laboral y brindarte herramientas modernas y seguras
            para gestionar trámites y servicios en línea.
          </p>

          {/* Lista de funcionalidades */}
          <p className='mb-2 text-secondary-light text-lg'>
            Aquí podrás:
          </p>
          <ul className='mb-10 text-secondary-light text-lg ps-4'>
            <li>Consultar y descargar tus comprobantes de nómina de manera rápida y sencilla.</li>
            <li>Recibir notificaciones importantes sobre tu centro de trabajo y el Ayuntamiento de Comondú.</li>
          </ul>

          <p className='mb-10 text-secondary-light text-lg'>
            Nuestra meta es <strong>modernizar y simplificar la comunicación</strong> entre el trabajador
            y la administración, ofreciéndote un sistema seguro, accesible desde cualquier dispositivo
            y disponible las 24 horas.
            <br />
            <strong>¡Gracias por ser parte de Comondú!</strong> Tu esfuerzo es clave para el crecimiento
            y bienestar de nuestro municipio.
          </p>
        </>
      )}

      {/* Dashboard SOLO para ADMINISTRADOR */}
      {hasRole('ADMINISTRADOR') && (
        <>
          <UpgradeYourPlan />
          <TransactionsTwo />
          <RevenueStatisticOne />
          <AverageDailySales />
          <RecentActivityOne />
        </>
      )}
    </div>
  );
};

export default DashBoardLayerNine;
